// extracted by mini-css-extract-plugin
export default {"alertContainer":"RbGWVJzZs_HazPuSAe8J","documentName":"Te1TjDrBN3v7ue5vqaM4"};